<div class="attente-screen">

  <!-- Grain texture overlay -->
  <div class="grain"></div>

  <!-- Floating geometric blobs -->
  <div class="blob blob-1"></div>
  <div class="blob blob-2"></div>
  <div class="blob blob-3"></div>

  <!-- Main card -->
  <div class="card">

    <!-- Wordmark -->
    <div class="wordmark">
      <span class="wordmark-la">La</span>
      <span class="wordmark-base">BASE</span>
    </div>

    <!-- Seal animation -->
    <div class="seal-wrapper">
      <div class="seal-ring seal-ring-outer"></div>
      <div class="seal-ring seal-ring-mid"></div>
      <div class="seal-body">
        <svg class="seal-icon" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <!-- Document -->
          <rect x="10" y="6" width="28" height="36" rx="3" stroke="currentColor" stroke-width="2.5" fill="none"/>
          <line x1="16" y1="16" x2="32" y2="16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <line x1="16" y1="22" x2="32" y2="22" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <line x1="16" y1="28" x2="26" y2="28" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          <!-- Checkmark shield -->
          <circle cx="33" cy="33" r="9" fill="#de0f17"/>
          <polyline points="29,33 32,36 37,30" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
        </svg>
        <div class="seal-pulse"></div>
      </div>
      <div class="seal-orbit">
        <div class="orbit-dot"></div>
      </div>
    </div>

    <!-- Heading -->
    <h1 class="heading">
      Vérification<br>
      <em>en cours</em>
    </h1>

    <p class="subtext">
      Votre certificat de scolarité a bien été reçu.<br>
      Notre équipe le vérifie manuellement.
    </p>

    <!-- Timeline -->
    <div class="timeline">
      <div class="step done">
        <div class="step-dot">
          <ion-icon name="checkmark-outline"></ion-icon>
        </div>
        <div class="step-line"></div>
        <span class="step-label">Certificat soumis</span>
      </div>

      <div class="step active">
        <div class="step-dot">
          <div class="pulse-ring"></div>
          <ion-icon name="hourglass-outline"></ion-icon>
        </div>
        <div class="step-line"></div>
        <span class="step-label">Vérification admin</span>
        <span class="step-eta">~ 48h</span>
      </div>

      <div class="step pending">
        <div class="step-dot">
          <ion-icon name="school-outline"></ion-icon>
        </div>
        <span class="step-label">Accès accordé</span>
      </div>
    </div>

    <!-- Actions -->
    <button class="btn-refresh" [class.spinning]="isRefreshing" (click)="onRefresh()">
      <ion-icon name="refresh-outline"></ion-icon>
      Vérifier le statut
    </button>

    <button class="btn-logout" (click)="logout.emit()">
      <ion-icon name="log-out-outline"></ion-icon>
      Se déconnecter
    </button>

  </div>

</div>
